'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _page = require('../module_biz/list/list/page');

var _page2 = _interopRequireDefault(_page);

var _selectVoucherPage = require('../module_biz/list/list/selectVoucherPage');

var _selectVoucherPage2 = _interopRequireDefault(_selectVoucherPage);

var _draftList = require('../module_biz/list/draftList');

var _draftList2 = _interopRequireDefault(_draftList);

var _page3 = require('../module_biz/setPrintSetting/page');

var _page4 = _interopRequireDefault(_page3);

var _SettingPage = require('../module_biz/setPrintSetting/page/SettingPage');

var _SettingPage2 = _interopRequireDefault(_SettingPage);

var _SelectPage = require('../module_biz/setPrintSetting/page/SelectPage');

var _SelectPage2 = _interopRequireDefault(_SelectPage);

var _settingList = require('../module_biz/settingList');

var _settingList2 = _interopRequireDefault(_settingList);

var _voucherListSet = require('../module_biz/voucherListSet');

var _voucherListSet2 = _interopRequireDefault(_voucherListSet);

var _mutantsMicrofx = require('mutants-microfx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageConfig = function () {
    function PageConfig() {
        var _this = this;

        (0, _classCallCheck3.default)(this, PageConfig);

        this.registerFilterConfig = function (filterConfig) {
            var bizCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            if (bizCode) {
                _this[bizCode] = {};
                _this[bizCode].filterConfig = filterConfig;
                return;
            }
            _this.filterConfig = filterConfig;
        };

        this.setCustomerIDField = function (field) {
            _this.customerIDField = field;
        };

        this.registerListRouterConfig = function (listRouter) {
            var routers = listRouter.map(function (item) {
                var component = item.chooseVoucher ? _selectVoucherPage2.default : _page2.default;
                return {
                    path: item.path,
                    component: component,
                    props: item.props,
                    cache: item.cache
                };
            });
            routers.push({
                path: '/list/:sysid/:mid',
                component: _page2.default,
                cache: true
            });
            routers.push({
                path: '/list/draft',
                component: _draftList2.default
            });
            routers.push({
                path: '/printsettingvoucher',
                component: _page4.default,
                cache: true
            });
            routers.push({
                path: '/settingPage',
                component: _SettingPage2.default,
                cache: true
            });
            routers.push({
                path: '/SelectPage',
                component: _SelectPage2.default
            });
            routers.push({
                path: '/settinglist',
                component: _settingList2.default
            });
            routers.push({
                path: '/voucherListSet',
                component: _voucherListSet2.default
            });

            (0, _mutantsMicrofx.registerRoutes)(routers);
        };

        this.registerListBussinessConfig = function (listBussiness) {
            _this.listBussinessConfig = listBussiness;
        };

        this.registerAuthFieldName = function (authName) {
            _this.authFieldName = authName;
        };

        this.registerFuncsFieldName = function (funcsName) {
            _this.funcsFieldName = funcsName;
        };

        this.getAuthFieldName = function () {
            if (!_this.authFieldName) {
                throw '未配置权限参数，请配置';
            }
            return _this.authFieldName;
        };

        this.getFilterConfig = function () {
            var bizCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var filterConfig = _this[bizCode] ? _this[bizCode].filterConfig : _this.filterConfig;
            if (!filterConfig) {
                throw '未配置过滤参数，请配置';
            }
            return filterConfig;
        };

        this.getFuncsFieldName = function () {
            if (!_this.funcsFieldName) {
                throw '未配置功能授权参数，请配置';
            }
            return _this.funcsFieldName;
        };

        this.getListBussinessConfig = function () {
            if (!_this.listBussinessConfig) {
                throw '未配置列表逻辑参数，请配置';
            }
            return _this.listBussinessConfig;
        };

        this.listBussinessConfig = null; //列表逻辑参数
        this.authFieldName = null; //权限参数 {'PU02': 'PurchaseOrderFieldAuth'};
        this.funcsFieldName = null; //功能授权参数 {'PU02': 'MB1007001'} 
        this.customerIDField = 'partnerID';
        this.filterConfig = null;
    }

    (0, _createClass3.default)(PageConfig, [{
        key: 'CustomerIDField',
        get: function get() {
            return this.customerIDField;
        }

        //注册权限参数


        //注册列表路由


        //注册列表业务


        //注册权限参数


        //注册功能授权参数

    }], [{
        key: 'getInstance',
        value: function getInstance() {
            if (!this.instance) {
                this.instance = new PageConfig();
            }
            return this.instance;
        }
    }]);
    return PageConfig;
}();

exports.default = PageConfig.getInstance();